import * as auth from './auth.actions';
import { UserProfile } from './user-profile';

export interface State {
  isLoggedIn: boolean;
  profile: UserProfile;
}

const initialState: State = {
  isLoggedIn: false,
  profile: <UserProfile>{
    userId: '',
    email: '',
    emailVerified: false,
  },
};

export function reducer(state = initialState, action: auth.Actions): State {
  switch (action.type) {
    case auth.LOGIN:
      return Object.assign({}, state, { isLoggedIn: true, profile: action.payload });

    case auth.LOGOUT:
      return initialState;

    default:
      return state;
  }
}

export const getProfile = (state: State) => state.profile;



// WEBPACK FOOTER //
// /Users/shwld/project/shwld/home-counter/app_src/src/app/store/auth/auth.reducer.ts